import * as React from "react";

import { Grid, Table } from "semantic-ui-react";

import ReactDiffViewer from "react-diff-viewer-continued";

import { AuditLogEntryDto } from "../model";

interface Props {
    auditLogs: AuditLogEntryDto[] | null;
}

export const defaultDiffTableStyles = {
    line: {
        background: "none !important",
        border: "0 !important",
    },
    diffAdded: {
        padding: "0.2em !important",
    },
    diffRemoved: {
        padding: "0.2em !important",
    },
    content: {
        padding: "0.2em !important",
        border: "none !important",
    },
    marker: {
        border: "none !important",
    },
    diffContainer: {
        background: "inherit !important",
    },
    codeFold: {
        border: "0 !important",
        background: "inherit !important",
    },
};

export const AuditLogTable = ({ auditLogs }: Props) => {

    const prettyPrintJson = (data: any) => (<div><pre>{
        JSON.stringify(data, null, 2) }</pre></div>);

    const renderEventActionType = (log: AuditLogEntryDto) => {
        if (log.actionType) {
            return `${log.eventType} (${log.actionType})`;
        }

        return log.eventType;
    };

    return (
        <>
            <Grid.Row>
                <Grid.Column>
                    <Table>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell textAlign="center" width={2}>Event Type</Table.HeaderCell>
                                <Table.HeaderCell textAlign="center" width={2}>When</Table.HeaderCell>
                                <Table.HeaderCell textAlign="center" width={2}>User</Table.HeaderCell>
                                <Table.HeaderCell textAlign="center" width={10}>Changes</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            { auditLogs?.map((log, i) => (
                                <Table.Row key={i}>
                                    <Table.Cell>
                                        {renderEventActionType(log)}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {log.timeGenerated.toLocaleString()}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {prettyPrintJson(log.user)}
                                    </Table.Cell>
                                    <Table.Cell>
                                        <ReactDiffViewer
                                            styles={defaultDiffTableStyles}
                                            oldValue={JSON.stringify(log.before, null, 1)}
                                            newValue={JSON.stringify(log.after, null, 1)}
                                            splitView={false}
                                            disableWordDiff={true}
                                            hideLineNumbers={true}
                                            extraLinesSurroundingDiff={0}
                                        />
                                    </Table.Cell>
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                </Grid.Column>
            </Grid.Row>
        </>
    );
};
